<span class="version-text" *ngIf="version$ | async as version">
  v{{ version }}
</span>

